import { Modal } from "@mui/material";
import { useState } from "react";
import Select from "react-select";
import Swal from "sweetalert2";
import { tipoClienteOptions } from "../../../hook/Arreglos";
import { useDispatch } from "react-redux";
import { crearEmpresa } from "../../../store/Empresa/thunkEmpresa";
import { useLocation } from "react-router-dom";

export const ModalCrearEmpresa = ({ open, onClose, functions }) => {
    const location = useLocation();
    const [empresaData, setEmpresaData] = useState({
        nombre_empresa: "",
        razon_social: "",
        cedula_juridica: "",
        pagina_web: "",
        telefono: "",
        pais: "",
        direccion_fisica: "",
        industria: "",
        tipo_cliente: "Sin tipo",
        tiene_credito: "No",
        notas_importantes: "sin nota",
        logoEmpresa: "avatar.webp",
    });

    const [errors, setErrors] = useState({});

    const tieneCreditoOptions = [
        { value: "Si", label: "Sí" },
        { value: "No", label: "No" },
    ];

    const handleInputChange = ({ target: { name, value } }) => {
        setEmpresaData((prevData) => ({ ...prevData, [name]: value }));
        if (errors[name]) {
            setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
        }
    };

    const handleSelectChange = (option, { name }) => {
        setEmpresaData((prevData) => ({
            ...prevData,
            [name]: option ? option.value : "",
        }));
        if (errors[name]) {
            setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
        }
    };

    const validateFields = () => {
        const newErrors = {};
        Object.keys(empresaData).forEach((key) => {
            if (!empresaData[key] && key !== "logoEmpresa" && key !== "notas_importantes") {
                newErrors[key] = "Este campo es obligatorio";
            }
        });
        return newErrors;
    };

    const dispatch = useDispatch();

    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validateFields();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            Swal.fire("Campos Obligatorios", "Todos los campos en rojo son obligatorios.", "warning");
        } else {
            Swal.fire({
                title: "¿Está seguro?",
                text: "¿Desea crear la empresa con la información ingresada?",
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Sí, crear empresa",
                cancelButtonText: "Cancelar",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: "Creando empresa",
                        text: "Por favor espere...",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        didOpen: () => Swal.showLoading(),
                    });

                    await dispatch(crearEmpresa(empresaData));

                    Swal.fire({
                        icon: "success",
                        title: "Empresa creada",
                        text: "La empresa ha sido creada exitosamente.",
                        confirmButtonText: "Aceptar",
                    }).then(() => {
                        onClose();
                        const path = location.pathname.split("/");
                        if (path[1] === "evento" && path[2] === "crear") {
                            // No hacer nada (opcionalmente puedes añadir un comentario explicativo aquí)
                        } else if (path[1] === "cotizaciones" && path[2] === "crear") {
                            functions();
                        } else {
                            window.location.reload();
                        }
                    });
                }
            });
        }
    };

    return (
        <Modal open={open} onClose={onClose} className="modal fade show" aria-labelledby="exampleModalLongTitle" style={{ display: "block", zIndex: 1050 }} aria-modal="true" role="dialog">
            <div className="modal-dialog" role="document" style={{ maxWidth: "80%", margin: "1.75rem auto" }}>
                <div className="modal-content">
                    <div className="modal-body">
                        <p className="mb-0" style={{ fontSize: window.innerWidth < 600 ? "16px" : "28px" }}>
                            Crear una empresa
                        </p>
          
                            <div className="row">
                                {[
                                    { label: "Nombre Empresa", name: "nombre_empresa" },
                                    { label: "Razón Social", name: "razon_social" },
                                    { label: "Cédula Jurídica", name: "cedula_juridica" },
                                    { label: "Página Web", name: "pagina_web" },
                                    { label: "Teléfono", name: "telefono" },
                                    { label: "País", name: "pais" },
                                    { label: "Industria", name: "industria" },
                                ].map(({ label, name }) => (
                                    <div key={name} className="col-sm-6">
                                        <label>{label}:</label>
                                        <input type="text" name={name} value={empresaData[name]} onChange={handleInputChange} className={`form-control mb-2 ${errors[name] ? "is-invalid" : ""}`} />
                                        {errors[name] && <div className="invalid-feedback">{errors[name]}</div>}
                                    </div>
                                ))}
                                <div className="col-sm-6">
                                    <label>Dirección Física:</label>
                                    <textarea name="direccion_fisica" value={empresaData.direccion_fisica} onChange={handleInputChange} className={`form-control mb-2 ${errors.direccion_fisica ? "is-invalid" : ""}`}></textarea>
                                    {errors.direccion_fisica && <div className="invalid-feedback">{errors.direccion_fisica}</div>}
                                </div>
                                <div className="col-sm-6">
                                    <label>Tipo de Empresa:</label>
                                    <Select name="tipo_cliente" options={tipoClienteOptions} value={tipoClienteOptions.find((option) => option.value === empresaData.tipo_cliente) || null} onChange={handleSelectChange} className={`mb-2 ${errors.tipo_cliente ? "is-invalid" : ""}`} placeholder="Seleccione un tipo de cliente" />
                                    {errors.tipo_cliente && <div className="invalid-feedback">{errors.tipo_cliente}</div>}
                                </div>
                                <div className="col-sm-6">
                                    <label>¿Tiene Crédito?</label>
                                    <Select name="tiene_credito" options={tieneCreditoOptions} value={tieneCreditoOptions.find((option) => option.value === empresaData.tiene_credito) || null} onChange={handleSelectChange} className={`mb-2 ${errors.tiene_credito ? "is-invalid" : ""}`} />
                                    {errors.tiene_credito && <div className="invalid-feedback">{errors.tiene_credito}</div>}
                                </div>
                                <div className="col-sm-12">
                                    <label>Notas Importantes:</label>
                                    <textarea name="notas_importantes" value={empresaData.notas_importantes} onChange={handleInputChange} className="form-control mb-2"></textarea>
                                </div>
                            </div>
                            <button type="submit" className="btn btn-primary mt-3" onClick={handleSubmit}>
                                Guardar Empresa
                            </button>

                    </div>
                </div>
            </div>
        </Modal>
    );
};
